<template>
  <div>
    <div class="center">
      <el-image
        :src="$domain + 'static/noten/website/creation/chuangzuo_title2.png'"
        alt="少儿编程"
        style="width: 256px;height: 50px;margin-top: 100px;"
      ></el-image>
    </div>
    <div class="center">
      <div style="width: 1200px;margin: 30px 0px 100px 0px;" class="content">
        <div
          v-for="(i, index) in 17"
          :key="index"
          style="width: 280px;height: 310px;margin-top: 30px;border-radius: 10px;box-shadow: 0px 0px 5px 0px #e6e7e9;"
          @click="toWorkInfo"
        >
          <el-image
            :src="$domain + 'static/noten/website/newHome/top_banner1.png'"
            alt="少儿编程"
            style="width: 280px;height: 190px;border-radius: 10px 10px 0px 0px;"
          ></el-image>
          <div class="info">
            <div class="title ">
              深海寻宝
            </div>
            <!-- 点赞和浏览 -->
            <div class="row record">
              <div class="row">
                <div class="center-just" style="height: 11px;">
                  <el-image
                    :src="$domain + 'static/noten/website/creation/look.png'"
                    alt="少儿编程"
                    style="width: 14px;height: 10px;"
                  ></el-image>
                </div>
                <div class="center-just" style="margin-left: 5px;">1256</div>
              </div>
              <div class="row" style="margin-left: 21px;">
                <div class="center-just" style="height: 11px;">
                  <el-image
                    :src="$domain + 'static/noten/website/creation/dianzan.png'"
                    alt="少儿编程"
                    style="width: 11px;height: 11px;"
                  ></el-image>
                </div>
                <div class="center-just" style="margin-left: 5px;">1256</div>
              </div>
            </div>

            <div class="bar"></div>

            <!-- 用户数据 -->
            <div class="user">
              <div class="row">
                <el-image
                  :src="
                    $domain + 'static/noten/website/newHome/top_banner1.png'
                  "
                  alt="少儿编程"
                  style="width: 24px;height: 24px;border-radius: 50%;"
                ></el-image>
                <div class="username center-just">用户14546546</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    toWorkInfo() {
      this.$router.push("/creation/workInfo");
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  display: flex; //实现横排
  flex-wrap: wrap;
  justify-content: space-between;
  .info {
    margin: 0px 13px 0px 13px;
    .title {
      padding-top: 10px;
      width: 253px;
      height: 30px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 300;
      color: #1a1a1a;
      // display: table-cell;
      // vertical-align: middle;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .record {
      height: 11px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #1a1a1a;
    }
    .bar {
      width: 253px;
      height: 1px;
      background: #f2f2f2;
      margin-top: 12px;
    }
    .user {
      height: 52px;
      display: table-cell;
      vertical-align: middle;
      .username {
        margin-left: 8px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #333333;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/creation/components/works.vue